import IActionsResolver from 'globx/dist/Store/Interfaces/IActionsResolver';
import {Subject}        from 'rxjs';

import InteractionType     from '../../../Analytics/Interactions/Constants/InteractionType';
import IInteractionPayload from '../../../Analytics/Interactions/Interfaces/IInteractionPayload';

import VolumeStatus   from './Constants/VolumeStatus';
import IVolumeActions from './Interfaces/IVolumeActions';
import Volume         from './Volume';

const createVolumeActionsResolver = (
    interactions$: Subject<IInteractionPayload>
): IActionsResolver<Volume, IVolumeActions> => (
    value: Volume,
    actions: IVolumeActions
): IVolumeActions => ({
    dragToSetLevel(level: number): void {
        if (!value.isSliderActive) {
            actions.activateSlider();
            actions.setPreMuteLevel(value.level);
        }

        actions.setLevel(level);
    },

    setLevel(level: number): void {
        interactions$.next({
            type: level > value.level ?
                InteractionType.VOLUME_UP : InteractionType.VOLUME_DOWN
        });

        value.level = level;

        if (value.isMutedOrForceMuted && level > 0) {
            value.volumeStatus = VolumeStatus.AUDIBLE;
        } else if (!value.isMutedOrForceMuted && level === 0) {
            value.volumeStatus = VolumeStatus.MUTED;
        }
    },

    setPreMuteLevel(preMuteLevel: number): void {
        value.preMuteLevel = preMuteLevel;
    },

    mute(): void {
        value.preMuteLevel = value.level;
        value.volumeStatus = VolumeStatus.MUTED;

        value.level = 0;

        interactions$.next({
            type: InteractionType.MUTE
        });
    },

    forceMute(): void {
        value.preMuteLevel = value.level || value.preMuteLevel;
        value.volumeStatus = VolumeStatus.FORCE_MUTED;

        value.level = 0;
    },

    unMute(): void {
        value.volumeStatus = VolumeStatus.AUDIBLE;
        value.level = value.preMuteLevel;

        interactions$.next({
            type: InteractionType.UNMUTE
        });
    },

    activateSlider(): void {
        value.isSliderActive = true;
    },

    deactivateSlider(): void {
        value.isSliderActive = false;
    }

});

export default createVolumeActionsResolver;